import { Injectable } from '@angular/core';
import { DateTime } from 'src/app/utils/date-time';
import { PurecloudService } from '../purecloud/purecloud.service';
import * as platformClient from 'purecloud-platform-client-v2';
import Swal from 'sweetalert2'

class UserDetailsQuery implements platformClient.Models.UserDetailsQuery {
  constructor(public interval: string, public order: string, public paging: PagSpec ) {
  }
}
class PagSpec implements platformClient.Models.PagingSpec {
  constructor(public pageSize: number, public pageNumber: number) {
  }
}

@Injectable({
  providedIn: 'root'
})
export class AgentsLogsCloudService {

  constructor(private purecloudService : PurecloudService) { }

  public getUsersDetails( from:Date, to: Date ): Promise<any|Array<platformClient.Models.AnalyticsUserDetail>> {
    var interval = DateTime.convertDateToString(from) + '/' + DateTime.convertDateToString(to);
    return this.purecloudService.checkLogin() || new Promise<Array<platformClient.Models.AnalyticsUserDetail>>((resolve, reject) => {
      this.getUsersDetailsInternal(new UserDetailsQuery(interval, 'asc', new PagSpec(100,1)), new Array<platformClient.Models.AnalyticsUserDetail>(), resolve, reject);
    });
  }
  private getUsersDetailsInternal(opts: UserDetailsQuery, users: Array<platformClient.Models.AnalyticsUserDetail>, resolve, reject) {
    console.log('UserDetailQuery: ' + JSON.stringify(opts)); //! Borrar esto
    this.Toast.fire({
      title: "Estados considerados " + opts.paging.pageSize + ' de la pagina ' + opts.paging.pageNumber,
      timer: 1000
    });
    this.purecloudService.getUsersApi().postAnalyticsUsersDetailsQuery( opts )
      .then((response) => this.thenUsersDetails(response, opts , users, resolve, reject))
      .catch((response) => this.catchUsersDetails(response, reject));
  }
  private thenUsersDetails(response: platformClient.Models.AnalyticsUserDetailsQueryResponse,opts: UserDetailsQuery, usersDetails: Array<platformClient.Models.AnalyticsUserDetail>, resolve, reject) {
    if(response.userDetails !== undefined) {
      response.userDetails.forEach( (userDetail) => {
        usersDetails.push(userDetail);
      });
      opts.paging.pageNumber++;
      this.getUsersDetailsInternal(opts ,usersDetails , resolve, reject);
    } else {
      resolve(usersDetails);
    }
  }
  private catchUsersDetails(response: any, reject) {
    reject(response);
  }

  private Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1000
  });
}
